import React from 'react';
import { useTranslation } from 'react-i18next';
import * as z from 'zod/v3';
import { zodResolver } from '@hookform/resolvers/zod';
import { isValid, parseISO } from 'date-fns';
import { useForm } from 'react-hook-form';

export const getSocialSecurityNumberRegex = () => /^\d{3}-?\d{2}-?\d{4}$/;

export const validateISODateFormat = (val) => {
  return val ? isValid(parseISO(val)) : true;
};

const useCreateApplicationForm = () => {
  const { t } = useTranslation();

  const schema = React.useMemo(() => {
    return z.object({
      firstName: z.string().nonempty({ message: t('common.requiredFieldFirstName') }),
      lastName: z.string().nonempty({ message: t('common.requiredFieldLastName') }),
      address: z.string().nonempty({ message: t('common.requiredFieldStreet') }),
      city: z.string().nonempty({ message: t('common.requiredFieldCity') }),
      state: z.string().nonempty({ message: t('common.requiredFieldState') }),
      zip: z.string().nonempty({ message: t('common.requiredFieldPostalCode') }),
      email: z
        .string()
        .nonempty({ message: t('common.requiredFieldEmail') })
        .email({ message: t('common.invalidFormatEmail') }),
      socialSecurityNumber: z
        .string()
        .nonempty({ message: t('common.requiredFieldSSN') })
        .refine(
          (val) => {
            const regex = getSocialSecurityNumberRegex();
            return regex.test(val);
          },
          { message: t('common.invalidFormatSSN') }
        ),
      phone: z.string().nonempty({ message: t('common.requiredFieldPhone') }),
      dateOfBirth: z
        .any()
        .refine(validateISODateFormat, { message: t('common.invalidDateFormat') }),
      annualIncome: z
        .string()
        .transform(parseInt)
        .refine((val) => val >= 1, { message: t('common.requiredFieldAnnualIncome') }),
      terms: z.boolean().refine((val) => val, { message: t('common.requiredFieldTerms') }),
    });
  }, [t]);

  return useForm({
    resolver: zodResolver(schema),
  });
};

export default useCreateApplicationForm;
